import type { IState } from '~redux/state';
import { timelyApi } from './timely.apiSlice';

/**
 * Base for reading the Timely RTK Query slice off the root state.
 * Mirrors `../../tic/api-slice/tic.api.selector.ts`.
 */
export const getTimelyApiSlice = (state: IState) => state[timelyApi.reducerPath];
